export enum TSDIPositions {
    APARClerk = 0,
    AccountOfficer,
    AccountReceivableAdmin,
    AccountAssociate,
    AccountManager,
    AccountReceivableCoordinator,
}

export default class TSDIPosition {
    id: number;
    isSelected: boolean;
    name: string;
}



// WEBPACK FOOTER //
// ./src/models/personnel/TSDIPosition.ts